import axiosInstance from '@/services/axiosInstance'

async function getVideos () {
  const req = {
    url: 'api/config/getvideosportal',
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
  }
  const res = await axiosInstance(req)
  return res.data
}

export { getVideos }
